<mat-form-field>
  <mat-label>
    {{ to.label }}
    <span *ngIf="to.required && to.hideRequiredMarker !== true">*</span>
  </mat-label>

  <input matInput #passwordField [type]="inputType" [formControl]="formControl" [formlyAttributes]="field" />

  <mat-icon (click)="visibilityToggle()">{{icon}}</mat-icon>
  <mat-error>
    <formly-validation-message [field]="field"></formly-validation-message>
  </mat-error>
</mat-form-field>
